var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 1010,
    viewBox: "0 0 428 1010",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-284.5 723.1H0.200012V437.6L-284.5 723.1Z",
    fill: "#F2F6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 722.9C143.1 801.7 79.3996 865.6 0.799606 865.6V722.9H-141.4C-141.4 644.2 -77.7004 580.3 0.799606 580.3C79.3996 580.3 143.1 644.2 143.1 722.9Z",
    fill: "#064DA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799606 865.6C-77.8004 865.6 -141.4 801.7 -141.4 722.9H0.799606V865.6Z",
    fill: "#77B75A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800201 651.6C-38.4998 651.6 -70.2998 683.5 -70.2998 722.9C-70.2998 762.3 -38.4998 794.3 0.800201 794.3C40.1002 794.3 71.9002 762.3 71.9002 722.9C71.9002 683.5 40.1002 651.6 0.800201 651.6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 865.6C64.4998 865.6 0.799805 801.7 0.799805 722.9C79.3998 722.9 143.1 786.8 143.1 865.6Z",
    fill: "#FABD29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-141.4 580.3C-62.9004 580.3 0.799606 644.2 0.799606 722.9C-77.7004 722.9 -141.4 659.1 -141.4 580.3Z",
    fill: "#77C7EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 580.3C221.6 580.3 285.3 644.2 285.3 722.9C206.8 722.9 143.1 659.1 143.1 580.3Z",
    fill: "#77C7EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M285.3 437.6C206.8 437.6 143.1 501.5 143.1 580.2C221.6 580.2 285.3 516.4 285.3 437.6Z",
    fill: "#77B75A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 580.3C143.1 659.1 79.3998 722.9 0.799805 722.9C0.799805 644.2 64.4998 580.3 143.1 580.3Z",
    fill: "#E96345"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-34.8998 972.3L-70.4998 1007.9L-106.2 972.3L-141.8 1007.9V972.3L-106.2 936.8L-70.4998 972.3L-34.8998 936.8L0.800201 972.3V1007.9L-34.8998 972.3Z",
    fill: "#FABD29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-70.4998 936.8L-106.2 901.2L-141.8 936.8V901.2L-106.2 865.6L-70.4998 901.2L-34.8998 865.6L0.800201 901.2V936.8L-34.8998 901.2L-70.4998 936.8Z",
    fill: "#6363A7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.7 1007.9H143.1V865.3H122.7V1007.9Z",
    fill: "#77C7EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0996 1007.9H102.4V865.3H82.0996V1007.9Z",
    fill: "#77C7EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 1007.9H21.0998V865.3H0.799805V1007.9Z",
    fill: "#77C7EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 1007.9H61.8V865.3H41.5V1007.9Z",
    fill: "#77C7EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 1007.9C221.6 1007.9 285.3 944 285.3 865.3H143.1V1007.9Z",
    fill: "#77B75A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.1 722.9V865.6H285.3V722.9H143.1Z",
    fill: "#DCE4EF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M178.3 758.3V830.2H250.1V758.3H178.3Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.700195 437.6V580.3H143.1V437.6H0.700195Z",
    fill: "#DCE4EF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4002 508.9C41.6002 525.8 55.1002 539.2 71.9002 540.5V540.7C55.1002 542 41.6002 555.4 40.4002 572.3H40.3002C39.0002 555.4 25.6002 542 8.7002 540.7V540.5C25.6002 539.2 39.0002 525.8 40.3002 508.9H40.4002Z",
    fill: "#064DA1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4002 445.6C41.6002 462.4 55.1002 475.9 71.9002 477.2V477.4C55.1002 478.7 41.6002 492.1 40.4002 508.9H40.3002C39.0002 492.1 25.6002 478.7 8.7002 477.4V477.2C25.6002 475.9 39.0002 462.4 40.3002 445.6H40.4002Z",
    fill: "#064DA1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 508.9C104.8 525.8 118.2 539.2 135.1 540.5V540.7C118.2 542 104.8 555.4 103.5 572.3H103.4C102.2 555.4 88.7004 542 71.9004 540.7V540.5C88.7004 539.2 102.2 525.8 103.4 508.9H103.5Z",
    fill: "#064DA1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 445.6C104.8 462.4 118.2 475.9 135.1 477.2V477.4C118.2 478.7 104.8 492.1 103.5 508.9H103.4C102.2 492.1 88.7004 478.7 71.9004 477.4V477.2C88.7004 475.9 102.2 462.4 103.4 445.6H103.5Z",
    fill: "#064DA1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M428 143C428 221.8 364.3 285.6 285.7 285.6V143H143.4C143.4 64.2 207.1 0.399902 285.7 0.399902C364.3 0.399902 428 64.2 428 143Z",
    fill: "#064DA1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 285.6C207.1 285.6 143.4 221.8 143.4 143H285.7V285.6Z",
    fill: "#77B75A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M428 285.6C349.4 285.6 285.7 221.8 285.7 143C364.3 143 428 206.8 428 285.6Z",
    fill: "#FABD29"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.4 0.399902C222 0.399902 285.7 64.2 285.7 143C207.1 143 143.4 79.0999 143.4 0.399902Z",
    fill: "#77C7EE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M428 0.399902C428 79.0999 364.3 143 285.7 143C285.7 64.2 349.4 0.399902 428 0.399902Z",
    fill: "#E96345"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4 392.4L71.7004 428L36.1004 392.4L0.400391 428V392.4L36.1004 356.8L71.7004 392.4L107.4 356.8L143.1 392.4V428L107.4 392.4Z",
    fill: "#064DA1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7004 356.8L36.1004 321.3L0.400391 356.8V321.3L36.1004 285.7L71.7004 321.3L107.4 285.7L143.1 321.3V356.8L107.4 321.3L71.7004 356.8Z",
    fill: "#77B75A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M250 392.4L214.4 428L178.7 392.4L143.1 428V392.4L178.7 356.8L214.4 392.4L250 356.8L285.7 392.4V428L250 392.4Z",
    fill: "#FABD29"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M214.4 356.8L178.7 321.3L143.1 356.8V321.3L178.7 285.7L214.4 321.3L250 285.7L285.7 321.3V356.8L250 321.3L214.4 356.8Z",
    fill: "#6363A7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 142.9V285.6H142.8V142.9H0.400391Z",
    fill: "#77C7EE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 259.2C121.9 262.3 119.4 264.7 116.4 264.7C113.3 264.7 110.8 262.3 110.8 259.2C110.8 256.1 113.3 253.6 116.4 253.6C119.4 253.6 121.9 256.1 121.9 259.2Z",
    fill: "#FABD29"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 236.7C121.9 239.8 119.4 242.3 116.4 242.3C113.3 242.3 110.8 239.8 110.8 236.7C110.8 233.7 113.3 231.2 116.4 231.2C119.4 231.2 121.9 233.7 121.9 236.7Z",
    fill: "#FABD29"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 214.3C121.9 217.3 119.4 219.8 116.4 219.8C113.3 219.8 110.8 217.3 110.8 214.3C110.8 211.2 113.3 208.7 116.4 208.7C119.4 208.7 121.9 211.2 121.9 214.3Z",
    fill: "#FABD29"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.9 191.8C121.9 194.9 119.4 197.4 116.4 197.4C113.3 197.4 110.8 194.9 110.8 191.8C110.8 188.7 113.3 186.3 116.4 186.3C119.4 186.3 121.9 188.7 121.9 191.8Z",
    fill: "#FABD29"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8 169.4C110.8 166.3 113.3 163.8 116.4 163.8C119.4 163.8 121.9 166.3 121.9 169.4C121.9 172.4 119.4 174.9 116.4 174.9C113.3 174.9 110.8 172.4 110.8 169.4Z",
    fill: "#FABD29"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 259.2C99.5004 262.3 97.1004 264.7 94.0004 264.7C90.9004 264.7 88.4004 262.3 88.4004 259.2C88.4004 256.1 90.9004 253.6 94.0004 253.6C97.1004 253.6 99.5004 256.1 99.5004 259.2Z",
    fill: "#FABD29"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 236.7C99.5004 239.8 97.1004 242.3 94.0004 242.3C90.9004 242.3 88.4004 239.8 88.4004 236.7C88.4004 233.7 90.9004 231.2 94.0004 231.2C97.1004 231.2 99.5004 233.7 99.5004 236.7Z",
    fill: "#FABD29"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 214.3C99.5004 217.3 97.1004 219.8 94.0004 219.8C90.9004 219.8 88.4004 217.3 88.4004 214.3C88.4004 211.2 90.9004 208.7 94.0004 208.7C97.1004 208.7 99.5004 211.2 99.5004 214.3Z",
    fill: "#FABD29"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 191.8C99.5004 194.9 97.1004 197.4 94.0004 197.4C90.9004 197.4 88.4004 194.9 88.4004 191.8C88.4004 188.7 90.9004 186.3 94.0004 186.3C97.1004 186.3 99.5004 188.7 99.5004 191.8Z",
    fill: "#FABD29"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5004 169.4C99.5004 172.4 97.1004 174.9 94.0004 174.9C90.9004 174.9 88.4004 172.4 88.4004 169.4C88.4004 166.3 90.9004 163.8 94.0004 163.8C97.1004 163.8 99.5004 166.3 99.5004 169.4Z",
    fill: "#FABD29"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 259.2C77.1 262.3 74.7 264.7 71.6 264.7C68.5 264.7 66 262.3 66 259.2C66 256.1 68.5 253.6 71.6 253.6C74.7 253.6 77.1 256.1 77.1 259.2Z",
    fill: "#FABD29"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 236.7C77.1 239.8 74.7 242.3 71.6 242.3C68.5 242.3 66 239.8 66 236.7C66 233.7 68.5 231.2 71.6 231.2C74.7 231.2 77.1 233.7 77.1 236.7Z",
    fill: "#FABD29"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 214.3C77.1 217.3 74.7 219.8 71.6 219.8C68.5 219.8 66 217.3 66 214.3C66 211.2 68.5 208.7 71.6 208.7C74.7 208.7 77.1 211.2 77.1 214.3Z",
    fill: "#FABD29"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 191.8C77.1 194.9 74.7 197.4 71.6 197.4C68.5 197.4 66 194.9 66 191.8C66 188.7 68.5 186.3 71.6 186.3C74.7 186.3 77.1 188.7 77.1 191.8Z",
    fill: "#FABD29"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1 169.4C77.1 172.4 74.7 174.9 71.6 174.9C68.5 174.9 66 172.4 66 169.4C66 166.3 68.5 163.8 71.6 163.8C74.7 163.8 77.1 166.3 77.1 169.4Z",
    fill: "#FABD29"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6996 259.2C54.6996 262.3 52.2996 264.7 49.1996 264.7C46.0996 264.7 43.5996 262.3 43.5996 259.2C43.5996 256.1 46.0996 253.6 49.1996 253.6C52.2996 253.6 54.6996 256.1 54.6996 259.2Z",
    fill: "#FABD29"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6996 236.7C54.6996 239.8 52.2996 242.3 49.1996 242.3C46.0996 242.3 43.5996 239.8 43.5996 236.7C43.5996 233.7 46.0996 231.2 49.1996 231.2C52.2996 231.2 54.6996 233.7 54.6996 236.7Z",
    fill: "#FABD29"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6996 214.3C54.6996 217.3 52.2996 219.8 49.1996 219.8C46.0996 219.8 43.5996 217.3 43.5996 214.3C43.5996 211.2 46.0996 208.7 49.1996 208.7C52.2996 208.7 54.6996 211.2 54.6996 214.3Z",
    fill: "#FABD29"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6996 191.8C54.6996 194.9 52.2996 197.4 49.1996 197.4C46.0996 197.4 43.5996 194.9 43.5996 191.8C43.5996 188.7 46.0996 186.3 49.1996 186.3C52.2996 186.3 54.6996 188.7 54.6996 191.8Z",
    fill: "#FABD29"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6996 169.4C54.6996 172.4 52.2996 174.9 49.1996 174.9C46.0996 174.9 43.5996 172.4 43.5996 169.4C43.5996 166.3 46.0996 163.8 49.1996 163.8C52.2996 163.8 54.6996 166.3 54.6996 169.4Z",
    fill: "#FABD29"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 259.2C32.3002 262.3 29.9002 264.7 26.8002 264.7C23.7002 264.7 21.2002 262.3 21.2002 259.2C21.2002 256.1 23.7002 253.6 26.8002 253.6C29.9002 253.6 32.3002 256.1 32.3002 259.2Z",
    fill: "#FABD29"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 236.7C32.3002 239.8 29.9002 242.3 26.8002 242.3C23.7002 242.3 21.2002 239.8 21.2002 236.7C21.2002 233.7 23.7002 231.2 26.8002 231.2C29.9002 231.2 32.3002 233.7 32.3002 236.7Z",
    fill: "#FABD29"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 214.3C32.3002 217.3 29.9002 219.8 26.8002 219.8C23.7002 219.8 21.2002 217.3 21.2002 214.3C21.2002 211.2 23.7002 208.7 26.8002 208.7C29.9002 208.7 32.3002 211.2 32.3002 214.3Z",
    fill: "#FABD29"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 191.8C32.3002 194.9 29.9002 197.4 26.8002 197.4C23.7002 197.4 21.2002 194.9 21.2002 191.8C21.2002 188.7 23.7002 186.3 26.8002 186.3C29.9002 186.3 32.3002 188.7 32.3002 191.8Z",
    fill: "#FABD29"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3002 169.4C32.3002 172.4 29.9002 174.9 26.8002 174.9C23.7002 174.9 21.2002 172.4 21.2002 169.4C21.2002 166.3 23.7002 163.8 26.8002 163.8C29.9002 163.8 32.3002 166.3 32.3002 169.4Z",
    fill: "#FABD29"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2002 0.200195C111.5 0.200195 143.4 32.1 143.4 71.5C104.1 71.5 72.2002 39.6002 72.2002 0.200195Z",
    fill: "#E96345"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2002 142.8C72.2002 103.5 104.1 71.5 143.4 71.5C143.4 110.9 111.5 142.8 72.2002 142.8Z",
    fill: "#E96345"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 0.200195C40.3996 0.200195 72.1996 32.1 72.1996 71.5C32.9996 71.5 1.09961 39.6002 1.09961 0.200195Z",
    fill: "#77B75A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 142.8C1.09961 103.5 32.9996 71.5 72.1996 71.5C72.1996 110.9 40.3996 142.8 1.09961 142.8Z",
    fill: "#77B75A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M285.7 866.7V1009.4H428V866.7H285.7Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M340 983C340 986.1 337.5 988.5 334.4 988.5C331.4 988.5 328.9 986.1 328.9 983C328.9 979.9 331.4 977.4 334.4 977.4C337.5 977.4 340 979.9 340 983Z",
    fill: "#FABD29"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M340 960.5C340 963.6 337.5 966.1 334.4 966.1C331.4 966.1 328.9 963.6 328.9 960.5C328.9 957.4 331.4 955 334.4 955C337.5 955 340 957.4 340 960.5Z",
    fill: "#FABD29"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M340 938.1C340 941.1 337.5 943.6 334.4 943.6C331.4 943.6 328.9 941.1 328.9 938.1C328.9 935 331.4 932.5 334.4 932.5C337.5 932.5 340 935 340 938.1Z",
    fill: "#FABD29"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M340 915.6C340 918.7 337.5 921.2 334.4 921.2C331.4 921.2 328.9 918.7 328.9 915.6C328.9 912.5 331.4 910 334.4 910C337.5 910 340 912.5 340 915.6Z",
    fill: "#FABD29"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M340 893.2C340 896.2 337.5 898.7 334.4 898.7C331.4 898.7 328.9 896.2 328.9 893.2C328.9 890.1 331.4 887.6 334.4 887.6C337.5 887.6 340 890.1 340 893.2Z",
    fill: "#FABD29"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M317.6 983C317.6 986.1 315.1 988.5 312 988.5C309 988.5 306.5 986.1 306.5 983C306.5 979.9 309 977.4 312 977.4C315.1 977.4 317.6 979.9 317.6 983Z",
    fill: "#FABD29"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M317.6 960.5C317.6 963.6 315.1 966.1 312 966.1C309 966.1 306.5 963.6 306.5 960.5C306.5 957.4 309 955 312 955C315.1 955 317.6 957.4 317.6 960.5Z",
    fill: "#FABD29"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M317.6 938.1C317.6 941.1 315.1 943.6 312 943.6C309 943.6 306.5 941.1 306.5 938.1C306.5 935 309 932.5 312 932.5C315.1 932.5 317.6 935 317.6 938.1Z",
    fill: "#FABD29"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M317.6 915.6C317.6 918.7 315.1 921.2 312 921.2C309 921.2 306.5 918.7 306.5 915.6C306.5 912.5 309 910 312 910C315.1 910 317.6 912.5 317.6 915.6Z",
    fill: "#FABD29"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M317.6 893.2C317.6 896.2 315.1 898.7 312 898.7C309 898.7 306.5 896.2 306.5 893.2C306.5 890.1 309 887.6 312 887.6C315.1 887.6 317.6 890.1 317.6 893.2Z",
    fill: "#FABD29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCountdown);
export default __webpack_public_path__ + "static/media/left_countdown.b5d47ed51cbca766a6e70d9cdac2acb5.svg";
export { ForwardRef as ReactComponent };